export default class DependentField {
    constructor(element) {
        this.$field = $(element);
        this.$dependentField = $(this.$field.data('dependentField'));
    }

    setDefaultValue() {
        if (this.$dependentField.is('select')) {
            // Select first element
            this.$dependentField.prop('selectedIndex', 0);
        } else {
            this.$dependentField.val('');
        }
    }

    enableDependentField() {
        let defaultValue = this.$dependentField.data('defaultValue');

        this.$dependentField.removeAttr('disabled');

        if (defaultValue) {
            this.$dependentField.val(defaultValue);
        } else {
            this.setDefaultValue();
        }

        this.$dependentField.trigger('element:enable');
    }

    disableDependentField() {
        this.$dependentField.attr('disabled', true);
        this.setDefaultValue();
        this.$dependentField.trigger('element:disable');
    }

    changeField() {
        let fieldType = this.$field.data('type');
        let dependentFieldType = this.$dependentField.data('type');

        if (typeof dependentFieldType !== 'undefined') {
            if (this.$field.val() && dependentFieldType === fieldType) {
                this.enableDependentField();
            } else {
                this.disableDependentField();
            }
        } else {
            if (this.$field.val()) {
                this.enableDependentField();
            } else {
                this.disableDependentField();
            }
        }
    }

    setListeners() {
        this.$field
            .off('change.DependentField', '', $.proxy(this, 'changeField'))
            .on('change.DependentField', $.proxy(this, 'changeField'));
    }

    init() {
        this.setListeners();
    }
}
